import * as Types from "../schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetGlobalAdminDataQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetGlobalAdminDataQuery = { __typename?: "query_root" } & {
  app_users: Array<
    { __typename?: "app_users" } & Pick<
      Types.App_Users,
      | "app_tour_completed"
      | "created_at"
      | "email"
      | "id"
      | "is_admin"
      | "last_logged_in"
      | "name"
      | "phone_number"
    > & {
        image?: Types.Maybe<
          { __typename?: "uploads" } & Pick<
            Types.Uploads,
            "s3_key" | "s3_level"
          >
        >;
        selected_organisation?: Types.Maybe<
          { __typename?: "organisations" } & Pick<
            Types.Organisations,
            "id" | "name"
          > & {
              image?: Types.Maybe<
                { __typename?: "uploads" } & Pick<
                  Types.Uploads,
                  "s3_key" | "s3_level"
                >
              >;
            }
        >;
        organisations: Array<
          { __typename?: "organisation_users" } & {
            organisation: { __typename?: "organisations" } & Pick<
              Types.Organisations,
              "id" | "name"
            > & {
                image?: Types.Maybe<
                  { __typename?: "uploads" } & Pick<
                    Types.Uploads,
                    "s3_key" | "s3_level"
                  >
                >;
              };
          }
        >;
      }
  >;
  organisation_banks: Array<
    { __typename?: "organisation_banks" } & Pick<
      Types.Organisation_Banks,
      "id" | "bank_id" | "organisation_id"
    > & {
        organisation: { __typename?: "organisations" } & Pick<
          Types.Organisations,
          "name"
        >;
        bank: { __typename?: "banks" } & Pick<Types.Banks, "name">;
      }
  >;
  organisation_users: Array<
    { __typename?: "organisation_users" } & Pick<
      Types.Organisation_Users,
      "id" | "user_id" | "organisation_id"
    > & {
        organisation: { __typename?: "organisations" } & Pick<
          Types.Organisations,
          "name"
        >;
        user: { __typename?: "app_users" } & Pick<Types.App_Users, "name">;
      }
  >;
};

export const GetGlobalAdminDataDocument = gql`
  query GetGlobalAdminData {
    app_users {
      app_tour_completed
      created_at
      email
      id
      is_admin
      last_logged_in
      name
      phone_number
      image {
        s3_key
        s3_level
      }
      selected_organisation {
        id
        name
        image {
          s3_key
          s3_level
        }
      }
      organisations {
        organisation {
          id
          name
          image {
            s3_key
            s3_level
          }
        }
      }
    }
    organisation_banks {
      id
      bank_id
      organisation_id
      organisation {
        name
      }
      bank {
        name
      }
    }
    organisation_users {
      id
      user_id
      organisation_id
      organisation {
        name
      }
      user {
        name
      }
    }
  }
`;

export function useGetGlobalAdminDataQuery(
  options: Omit<
    Urql.UseQueryArgs<GetGlobalAdminDataQueryVariables>,
    "query"
  > = {}
) {
  return Urql.useQuery<GetGlobalAdminDataQuery>({
    query: GetGlobalAdminDataDocument,
    ...options,
  });
}
